import emplacementDisponibiliteInitializer from '../catalogue/emplacementsDisponibiliteInitializer';

export function multiMarkerPanneaux(dictionaryMarker, clePosition, niveauDispo,
  MINIMUM_CLUSTER_SIZE) {
  dictionaryMarker[clePosition].panneaux = [];
  dictionaryMarker[clePosition].indexPanneauCourant = 0;
  dictionaryMarker[clePosition].minimumClusterSize = MINIMUM_CLUSTER_SIZE;
  dictionaryMarker[clePosition].niveauDisponibilite = niveauDispo.DISPONIBILITE_INDEFINI;
}

export function typesInformationsPanneaux(dictionaryMarker, clePosition, panneau, niveauDispo) {
  let listeNumFace = '';

  if (panneau.faces) {
    for (let index = 0; index < panneau.faces.length; index += 1) {
      const element = panneau.faces[index];
      listeNumFace = listeNumFace.concat("'", element.facNum, "',");
    }

    listeNumFace = listeNumFace.substring(0, listeNumFace.length - 1);
  }

  dictionaryMarker[clePosition].selected = dictionaryMarker[clePosition].selected
    || panneau.selected;
  dictionaryMarker[clePosition].azimut = panneau.azimut;
  dictionaryMarker[clePosition].panneaux.push({
    img: 'http://via.placeholder.com/350x150',
    num: panneau.num,
    selected: panneau.selected,
    namePlace: panneau.code,
    adresse1: panneau.adresseCommercialeLibelle1,
    adresse2: panneau.adresseCommercialeLibelle2,
    adresse3: panneau.adresseCommercialeLibelle3,
    ville: panneau.ville,
    format: panneau.format,
    surface: panneau.surface,
    materiel: panneau.materiel,
    eclaire: panneau.eclaire ? 'Oui' : 'Non',
    azimut: panneau.azimut,
    urlPhoto: panneau.urlPhoto,
    niveauDisponibilite: panneau.niveauDisponibilite,
    classNiveauDispo: niveauDispo.CLASS_NIVEAU_DISPONIBILITE[panneau.niveauDisponibilite],
    nbPropositions: panneau.nbPropositions,
    codeFaces: panneau.codeFaces,
    enAllantVers: panneau.enAllantVers,
    enVenantDe: panneau.enVenantDe,
    restrictions: panneau.restrictions,
    panneauOrigine: panneau, // panneau envoyer pour le panier si selection
    listeNumFace: listeNumFace,
  });
  // Pas top car appelé trop souvent
  emplacementDisponibiliteInitializer(dictionaryMarker[clePosition]);
}



// WEBPACK FOOTER //
// ./src/services/decorateur/decorateurMarkersPanneaux.js